import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.5 7.5H9C9.55228 7.5 10 7.05228 10 6.5V3C10 2.44772 9.55228 2 9 2H6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.5 4.5L1.5 7.5L4.5 10.5",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgEnter;
